import { useLocation } from 'react-router-dom';
import { SiteNav } from './components/site/SiteNav';
import { SiteFooter } from './components/site/SiteFooter';
import { StudioLoading } from './components/studio/StudioLoading';
import { StudioReadyProvider, useStudioEntrance } from './components/studio/studioEntrance';

// The studio (/projects and everything under it) has its own frame: each of its pages brings the
// studio bar, and there's no site nav or footer.
const isStudioRoute = (pathname) => /^\/projects(\/|$)/.test(pathname);

// A project's workspace behaves like an app rather than a page: from tablet width up it's exactly
// one screen tall with only its own panels scrolling. On phones it scrolls as a page, so the chat
// isn't squeezed under the clip list.
const isWorkspaceRoute = (pathname) => /^\/projects\/[^/]+/.test(pathname);

const AppWrapper = ({ children }) => {
  const { pathname } = useLocation();
  const inStudio = isStudioRoute(pathname);
  const inWorkspace = isWorkspaceRoute(pathname);
  const entrance = useStudioEntrance(inStudio);

  return (
    <StudioReadyProvider value={entrance.markReady}>
      <div className={`flex flex-col bg-base text-ink ${inWorkspace ? 'min-h-[100dvh] md:h-[100dvh] md:overflow-hidden' : 'min-h-[100dvh]'}`}>
        {!inStudio && <SiteNav />}
        {/* While the studio loads, its page renders underneath (so its data loads) but can't be reached */}
        <div inert={entrance.loading || undefined} className="flex-1 min-h-0 flex flex-col">{children}</div>
        {!inStudio && <SiteFooter />}
        {entrance.loading && <StudioLoading detail={inWorkspace ? 'Opening your project' : 'Loading your projects'} />}
      </div>
    </StudioReadyProvider>
  );
};

export default AppWrapper;
